export default __webpack_public_path__ + "static/media/icon-trash.b8295022.svg";